<template>
  <div class="page_all">
    <div class="return_link">
      <router-link to="/areaGroupList">＞ 地域グループ</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div v-if="this.changeFlg" class="title">地域グループの編集</div>
        <div v-else class="title">地域グループの追加</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button :disabled="$v.$invalid || this.updating" v-if="this.changeFlg" class="btn_general" v-on:click="areaGroupUpdate()">更新</button>
        <button :disabled="$v.$invalid || this.updating" v-else class="btn_general" v-on:click="areaGroupAdd()">追加</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_area">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="td_content">
              <div class="index_name">グループ名</div>
              <div><input v-model.trim="$v.groupName.$model" type="text" class="area_input"/></div>
              <div class="message">
                <div v-if="$v.groupName.$dirty">
                  <div class="error" v-if="!$v.groupName.required">グループ名は必須入力です。</div>
                  <div class="error" v-if="!$v.groupName.maxLength">グループ名は{{ $v.groupName.$params.maxLength.max }}文字以内で入力してください。</div>
                  <div class="error" v-if="!$v.groupName.customGroupName">すでに登録されているグループ名です。</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table_area">
        <thead>
          <tr>
            <th class="th_check">
              <input type="checkbox" v-model="isAllSelected" class="check_area">
            </th>
            <th class="th_area">地域名</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="area in areas" v-bind:key="area.id">
            <td>
              <input type="checkbox" v-bind:value=area.area_id v-model="selectedAreas" class="check_area">
            </td>
            <td class="area_name" disabled="true">{{ area.area_name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

const customGroupName = (municipalityGroupNames, changeFlg, groupNameDb) => (groupName) => {
  if (!groupName || typeof groupName != "string" || groupName === "") {
    return true
  }
  console.log("customGroup")
  console.log(municipalityGroupNames)
  console.log(groupNameDb)
  var groupSet = new Set(municipalityGroupNames)
  console.log(groupSet)
  
  if (changeFlg){
    groupSet.delete(groupNameDb)
  }
  console.log(municipalityGroupNames)
  if (groupSet.has(groupName)){
    console.log("1")
    return false
  } else {
    console.log("2")
    return true
  }
}

export default {
  data: function() {
    return {
        areas: null,
        areasAll: [],
        selectedAreas: [],

        groupId: "",
        groupName: "",
        areaFurigana: "",
        areaCode: "",
        // 変更フラグ
        changeFlg: false,
        // メッセージ
        message: "",
        updating: false,

        municipalityGroupList: null,
        municipalityGroupNames: null,
        groupNameDb: "",
    }
  },
	mounted() {
    // 変更フラグ
    this.changeFlg = this.$store.getters.getStateChangeFlg
    // 変更の場合はStoreから設定
    if (this.changeFlg) {
      this.groupId = this.$store.getters.getStateGroupId
      this.areaGroupDetail()
    }

    // 地域取得
    this.getAreaList()
    // 地域グループ取得 for validation
    this.getMunicipalityGroupList()
  },
  methods: {
    async getMunicipalityGroupList() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area-group/list', {
          params: {
          }
        })
        this.municipalityGroupList = response.data
        this.municipalityGroupNames = this.municipalityGroupList.map(x => x.group_name)
        console.log("group list")
        console.log(this.municipalityGroupNames)
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async areaGroupDetail() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area-group/detail', {
          params: {
            group_id: this.groupId
          }
        })
        this.groupName = response.data.group_name
        this.selectedAreas = response.data.areas
        this.groupNameDb = response.data.group_name

      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async getAreaList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "municipality_area_list"
        }
      })
      this.areas = response.data

      // チェックボックス全選択用
      for (var i= 0; i< this.areas.length; i++) {
        this.areasAll.push(this.areas[i].area_id)
      }
      // 変更の場合は詳細情報取得
      if (this.changeFlg) {
        this.areaGroupDetail()
      }
    },
    async areaGroupAdd() {
        console.log(this.selectedAreas)

        try {
            await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area-group/add', {
            municipality_key: this.$store.getters.getStateMunicipalityKey,
            group_name: this.groupName,
            areas: this.selectedAreas,
            charge_id: this.$store.getters.getStateChargeId
            })
            this.$router.push('/areaGroupList')
        } catch (err) {
            this.message = err.response.data.errorMessage;
        }
    },
    async areaGroupUpdate() {
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area-group/update', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          group_id: this.groupId,
          group_name: this.groupName,
          areas: this.selectedAreas,
          charge_id: this.$store.getters.getStateChargeId
        })
        this.$router.push('/areaGroupList')
      } catch (err) {
        this.message = err.response.data.errorMessage;
      }
    }
  },
  computed: {
    isAllSelected: {
      get: function () {
        return this.areas ? this.areas.length == this.selectedAreas.length : false;
      },
      set: function (checked) {
        this.selectedAreas = checked ? this.areasAll : []
      }
    }
  },
  validations() {
    return {
      groupName: {
        required,
        maxLength: maxLength(50),
        customGroupName: customGroupName(this.municipalityGroupNames, this.changeFlg, this.groupNameDb)
      },
    }
  }
}
</script>

<style scoped>
table th.th_area {
  text-align: left;
  padding-left: 10px;
}
.td_content {
  text-align: left;
  padding: 20px 20px 0px 20px;
}
.index_name {
  padding: 0px 0px 5px 0px;
}
.area_input {
  width: 758px;
}
.table_area {
    margin: 20px 0 0 0 ;
}
table th.th_check {
  width: 30px;
}
table th.th_area, .area_name{
  width: 800px;
}
table .th_area, .area_name{
  text-align: left;
  padding-left: 10px; 
}
</style>